class ViewService {
  get isMobileSize() {
    return window.innerWidth < 768;
  }
}

export const viewService = new ViewService();
